import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { Injectable } from '@angular/core';
import { GerarDanfeRequest } from '../../requests/report/gerar-danfe.request';
import { GerarPdfPorXmlRequest } from '../../requests/report/gerar-pdf-por-xml.request';

@Injectable({
  providedIn: 'root',
})
export class DanfeService extends CommonService {
  constructor(
    private httpClient: HttpClient
  ) {
    super();
  }

  // A URL base para o controller PanielContador.
  // Certifique-se de que a variável 'urlApiRepoDFe' existe no seu arquivo environment.ts
  private readonly apiUrl = `${environment.urlApiReport}Danfe`;

  /**
  * Faz o Download da DANFe.
  * @param nomeXml O nome da nota fiscal.
  */
  public gerarDANFe(request: GerarDanfeRequest): Observable<Blob> {
    const url = `${this.apiUrl}/gerarPdf`;
    // É crucial definir o responseType como 'blob' para receber o arquivo
    const options = {
      ...this.addHeaderToken(),
      responseType: 'blob' as 'json', // O cast é necessário por causa da tipagem padrão
    };

    return this.httpClient
      .post<Blob>(url, request, options)
      .pipe(catchError(this.handleError));
  }

  /**
   * Gera o DANFE a partir do XML enviado, sem buscar o arquivo no bucket. Em erro, a API devolve o
   * ReturnStruct em JSON com HTTP 200: o blob chega com tipo application/json.
   */
  public gerarPdfPorXml(request: GerarPdfPorXmlRequest): Observable<Blob> {
    const options = {
      ...this.addHeaderToken(),
      responseType: 'blob' as 'json',
    };

    return this.httpClient
      .post<Blob>(`${this.apiUrl}/gerarPdfPorXml`, request, options)
      .pipe(catchError(this.handleError));
  }
}
